import React, { useCallback, useEffect, useMemo, useState } from "react";
import axios from "axios";
import { useOutletContext } from "react-router-dom";

const API = "/api";
const uploadsBase = "/uploads";

const cardStyle = {
  background: "linear-gradient(135deg, rgba(255,255,255,0.92) 0%, rgba(248,250,252,0.98) 100%)",
  border: "1px solid rgba(148, 163, 184, 0.16)",
  borderRadius: "22px",
  padding: "18px",
  boxShadow: "0 16px 28px rgba(15, 23, 42, 0.06)",
};

const tableWrap = { overflowX: "auto", background: "#fff", borderRadius: "22px", padding: "10px", border: "1px solid rgba(148,163,184,.16)" };
const tableStyle = { width: "100%", borderCollapse: "collapse" };
const thStyle = { textAlign: "left", padding: "14px 12px", color: "#7c2d3a", borderBottom: "1px solid rgba(148, 163, 184, 0.16)", fontSize: "13px", background: "rgba(255,247,237,0.72)" };
const tdStyle = { padding: "14px 12px", borderBottom: "1px solid rgba(148, 163, 184, 0.12)", color: "#0f172a" };

function OurStudents() {
  const { franchise, selectedSession, availableSessions } = useOutletContext();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadRows = useCallback(async (sessionName = selectedSession) => {
    if (!franchise?.id) return;
    try {
      setLoading(true);
      const res = await axios.get(`${API}/franchise-portal/${franchise.id}/applications`, {
        params: {
          approved_only: 1,
          workflow_stage: "all",
          session_year: sessionName,
          _ts: Date.now(),
        },
      });
      setRows(Array.isArray(res.data) ? res.data : []);
    } catch (error) {
      setRows([]);
    } finally {
      setLoading(false);
    }
  }, [franchise?.id, selectedSession]);

  useEffect(() => {
    loadRows(selectedSession);
  }, [loadRows, selectedSession]);

  const summary = useMemo(() => ({
    total: rows.length,
    certified: rows.filter((row) => row.workflow_stage === "certified").length,
    registered: rows.filter((row) => row.workflow_stage === "registered").length,
  }), [rows]);

  return (
    <div style={{ display: "grid", gap: "18px" }}>
      <div style={cardStyle}>
        <div style={{ display: "flex", justifyContent: "space-between", gap: "14px", flexWrap: "wrap", alignItems: "center" }}>
          <div>
            <h2 style={{ margin: "0 0 6px", color: "#4e1b24" }}>Our Student</h2>
            <p style={{ margin: 0, color: "#6b3140", lineHeight: 1.7 }}>Session-wise total registered and passout student history for this franchise centre. Current filter: {selectedSession || "-"}</p>
          </div>
          <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
            <select className="form-select" value={selectedSession} disabled style={{ minWidth: "220px", backgroundColor: "#f8fafc" }}>
              {availableSessions.map((session) => (
                <option key={session} value={session}>{session}</option>
              ))}
            </select>
            <button type="button" className="btn btn-outline-secondary" onClick={() => loadRows(selectedSession)} disabled={loading}>
              {loading ? "Loading..." : "Refresh"}
            </button>
          </div>
        </div>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: "16px" }}>
        <div style={cardStyle}><div style={{ color: "#64748b", fontSize: "12px", fontWeight: 700 }}>Total Student</div><div style={{ marginTop: "10px", fontSize: "30px", fontWeight: 800 }}>{summary.total}</div></div>
        <div style={cardStyle}><div style={{ color: "#64748b", fontSize: "12px", fontWeight: 700 }}>Registered Student</div><div style={{ marginTop: "10px", fontSize: "30px", fontWeight: 800 }}>{summary.registered}</div></div>
        <div style={cardStyle}><div style={{ color: "#64748b", fontSize: "12px", fontWeight: 700 }}>Passout Student</div><div style={{ marginTop: "10px", fontSize: "30px", fontWeight: 800 }}>{summary.certified}</div></div>
      </div>

      <div style={tableWrap}>
        <table style={tableStyle}>
          <thead>
            <tr>
              <th style={thStyle}>Sl No</th>
              <th style={thStyle}>Registration No</th>
              <th style={thStyle}>Student</th>
              <th style={thStyle}>Course</th>
              <th style={thStyle}>Session</th>
              <th style={thStyle}>Stage</th>
              <th style={thStyle}>Status</th>
            </tr>
          </thead>
          <tbody>
            {!loading && rows.map((row, index) => (
              <tr key={row.id}>
                <td style={tdStyle}>{index + 1}</td>
                <td style={tdStyle}>{row.registration_no || "-"}</td>
                <td style={tdStyle}>
                  <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                    <img src={row.photo ? `${uploadsBase}/${row.photo}` : "https://placehold.co/52x52/e2e8f0/475569?text=ST"} alt={row.student_name} style={{ width: "52px", height: "52px", borderRadius: "14px", objectFit: "cover", border: "1px solid #e2e8f0" }} />
                    <div>
                      <div style={{ fontWeight: 700 }}>{row.student_name}</div>
                      <div style={{ color: "#64748b", fontSize: "12px" }}>{row.application_no || "-"}</div>
                    </div>
                  </div>
                </td>
                <td style={tdStyle}>{row.course_name || "-"}</td>
                <td style={tdStyle}>{row.session_year || "-"}</td>
                <td style={tdStyle} className="text-capitalize">{String(row.workflow_stage || "-").replaceAll("_", " ")}</td>
                <td style={tdStyle} className="text-capitalize">{row.status || "-"}</td>
              </tr>
            ))}
            {!loading && rows.length === 0 ? (
              <tr><td style={tdStyle} colSpan={7}>No student found for this session.</td></tr>
            ) : null}
            {loading ? (
              <tr><td style={tdStyle} colSpan={7}>Loading students...</td></tr>
            ) : null}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default OurStudents;
